import Vue from 'vue'
import dateTimeBoxVue from './DateTime.vue'

const defaultOptions = {
  title: '',
  date: '',
  minDate: '',
  maxDate: '',
  errorText: ''
}

let currentMsg, instance
const msgQueue = []
const DateTimeConstructor = Vue.extend(dateTimeBoxVue)

const defaultCallback = data => {
  if (currentMsg.resolve && currentMsg.reject) {
    if (data.action !== 'cancel') {
      currentMsg.resolve(data)
    } else {
      currentMsg.reject(data)
    }
  }
}

const initInstance = () => {
  instance = new DateTimeConstructor({
    el: document.createElement('div')
  })

  instance.callback = defaultCallback
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }
  if (!instance.value) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.value = true
      })
    }
  }
}

const DateTime = options => {
  return new Promise((resolve, reject) => {
    msgQueue.push({
      options: Object.assign({}, defaultOptions, options),
      callback: defaultCallback,
      resolve,
      reject
    })

    showNextMsg()
  })
}
function closeMask () {
  if (!instance) return
  instance.closeMask()
}

export default DateTime
export { DateTime, closeMask }
